export default __webpack_public_path__ + "static/media/ice_base@3x.f415feff.png";